import { Route, Routes } from "react-router-dom"
import { EstudeConoscoPosGraduacaoRoutes } from "./PosGraduacao"


const EstudeConoscoRoutes = () => {
    return (
        <Routes>
            <Route path='/posgraduacao/*' element={<EstudeConoscoPosGraduacaoRoutes />} />
        </Routes>
    )
}

export { EstudeConoscoRoutes };